module.exports = __webpack_public_path__ + "static/media/fig_1.8d116fed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_1.jpg
// module id = 626
// module chunks = 0